import React from "react";
import Modal, { ModalProps } from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";
import { useTranslation } from "react-i18next";

import "./StreakExpiringModal.scss";
import FilledButton from "../../FilledButton/FilledButton";
import ImageHourglass from "../../../../images/hourglass.svg";

interface StreakExpiringModalProps extends ModalProps {
  time: string;
}

function StreakExpiringModal(props: StreakExpiringModalProps) {
  const { time, onHide } = props;
  const { t } = useTranslation("common");

  return (
    <Modal
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="streak-expiring-modal"
      {...props}
    >
      <div className="MobileOnly info-modal-content">
        <Modal.Body className="modal-content">
          <p className="text-center">
            <Image
              src={ImageHourglass}
              alt="hourglass"
              height={105}
              width={105}
            />
          </p>
          <h2>{t("streak_expiring_soon")}</h2>
          <p className="explainer">
            {t("your_streak_expires_in")} <strong>{time}.</strong>{" "}
            {t("play_a_game_to_keep_your_streak")}!
          </p>
          <FilledButton onClick={onHide} style={{ height: 52 }}>
            {t("close")}
          </FilledButton>
        </Modal.Body>
      </div>
    </Modal>
  );
}

export default StreakExpiringModal;
